var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Parking icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4553",
    d: "M102.109 85.747a16.731 16.731 0 1 1-16.727-17.091 16.912 16.912 0 0 1 16.727 17.091z",
    transform: "translate(-65.382 -65.383)",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4554",
    d: "M124.365 109.094a15.64 15.64 0 1 1-15.636-16 15.821 15.821 0 0 1 15.636 16z",
    transform: "translate(-87.637 -87.639)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4555",
    d: "M52 35.636A16.364 16.364 0 1 0 68.364 52 16.364 16.364 0 0 0 52 35.636zM32 52a20 20 0 1 1 20 20 20 20 0 0 1-20-20z",
    style: {
      fillRule: "evenodd",
      fill: "#ff4545"
    },
    transform: "translate(-32 -32)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4556",
    d: "M190.836 143.779a1.818 1.818 0 0 1 1.818-1.818h6.356a6.372 6.372 0 1 1 0 12.743h-4.538v6.53a1.818 1.818 0 1 1-3.636 0zm3.636 7.288h4.538a2.735 2.735 0 1 0 0-5.47h-4.538z",
    transform: "translate(-176.654 -132.143)",
    style: {
      fill: "#565656",
      fillRule: "evenodd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.699d5817a7717e56a477290e18948739.svg";
export { ForwardRef as ReactComponent };